// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mafia-top-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2000;
    background: var(--tg-theme-bg-color, #ffffff);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: var(--tg-theme-text-color, #000000);
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

/* --- СТРОКА 1: ХЕДЕР --- */
.mtb-row-header {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    position: relative;
}

.mtb-timer-container {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 2;
    /* Полупрозрачность для таймера (как фон) */
    opacity: 0.5;
}

.mtb-timer {
    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, Roboto, sans-serif;
    font-size: 16px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    color: var(--tg-theme-text-color);
}

/* Добавляем букву s */
.mtb-timer::after {
    content: 's';
    font-size: 14px;
    font-weight: 600;
    margin-left: 1px;
    text-transform: lowercase;
}

.mtb-timer.danger {
    color: #ff3b30;
    animation: pulse 1s infinite;
    opacity: 1; /* Если опасно, убираем прозрачность */
}

.mtb-header-divider {
    width: 2px;
    height: 24px;
    background-color: currentColor; /* Использует цвет текста родителя */
    border-radius: 1px;
    opacity: 0.3;
}

/* Контейнер названия фазы */
.mtb-phase-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    /* Полупрозрачность для фазы */
    opacity: 0.5;
}

.mtb-phase-title {
    font-size: 16px; /* Увеличили шрифт */
    font-weight: 780; /* Сделали менее жирным (было 900) */
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--tg-theme-text-color);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50%;
}

.mtb-header-spacer { width: 40px; }


/* --- СТРОКА 2: ТАБЫ --- */
.mtb-row-tabs {
    /* Было 50px, уменьшаем на ~25% -> 38px */
    height: 26px;
    display: flex;
    padding: 3px 6px 3px 6px;
    gap: 6px;
}

.mtb-tab {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 7px;
    background: transparent;
    border: none;
    color: var(--tg-theme-hint-color, #999);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    overflow: hidden;
}

.mtb-tab.active {
    background: var(--tg-theme-button-color, #3390ec);
    color: var(--tg-theme-button-text-color, #ffffff);
    box-shadow: 0 2px 8px rgba(51, 144, 236, 0.25);
}
.mtb-tab:active { transform: scale(0.96); }

/* Иконки чуть меньше, чтобы влезло в 38px */
.mtb-tab.icon-only .mtb-tab-icon { font-size: 20px; }
.mtb-tab.with-text .mtb-tab-icon { font-size: 15px; }

.mtb-tab.with-text {
    flex-direction: row;
    gap: 4px;
    padding: 0 8px;
}

.mtb-tab-label {
    font-size: 12px; /* Оставляем читаемым */
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    padding-top: 1px; /* Визуальная компенсация */
}

/* Бейджи */
.mtb-alert-icon {
    top: 4px; right: 4px; font-size: 12px;
}

.mtb-badge {
    top: 2px; right: 2px;
    font-size: 9px;
    height: 14px; min-width: 14px;
    padding: 0 3px;
}

@keyframes pulse {
    0% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.7; transform: scale(0.95); }
    100% { opacity: 1; transform: scale(1); }
}
`, "",{"version":3,"sources":["webpack://./src/components/mafia/hud/MafiaTopBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA,4BAA4B;AAC5B;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,oFAAoF;IACpF,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,UAAU,EAAE,sCAAsC;AACtD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,8BAA8B,EAAE,oCAAoC;IACpE,kBAAkB;IAClB,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,eAAe,EAAE,oBAAoB;IACrC,gBAAgB,EAAE,oCAAoC;IACtD,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,qBAAqB,WAAW,EAAE;;;AAGlC,2BAA2B;AAC3B;IACI,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,uCAAuC;IACvC,eAAe;IACf,yDAAyD;IACzD,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,iDAAiD;IACjD,8CAA8C;AAClD;AACA,kBAAkB,sBAAsB,EAAE;;AAE1C,4CAA4C;AAC5C,mCAAmC,eAAe,EAAE;AACpD,mCAAmC,eAAe,EAAE;;AAEpD;IACI,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,eAAe,EAAE,uBAAuB;IACxC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,gBAAgB,EAAE,2BAA2B;AACjD;;AAEA,WAAW;AACX;IACI,QAAQ,EAAE,UAAU,EAAE,eAAe;AACzC;;AAEA;IACI,QAAQ,EAAE,UAAU;IACpB,cAAc;IACd,YAAY,EAAE,eAAe;IAC7B,cAAc;AAClB;;AAEA;IACI,KAAK,UAAU,EAAE,mBAAmB,EAAE;IACtC,MAAM,YAAY,EAAE,sBAAsB,EAAE;IAC5C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC5C","sourcesContent":[".mafia-top-bar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    z-index: 2000;\r\n    background: var(--tg-theme-bg-color, #ffffff);\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n    color: var(--tg-theme-text-color, #000000);\r\n    box-shadow: 0 4px 20px rgba(0,0,0,0.08);\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-bottom: 1px solid rgba(0,0,0,0.05);\r\n}\r\n\r\n/* --- СТРОКА 1: ХЕДЕР --- */\r\n.mtb-row-header {\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 20px;\r\n    position: relative;\r\n}\r\n\r\n.mtb-timer-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    z-index: 2;\r\n    /* Полупрозрачность для таймера (как фон) */\r\n    opacity: 0.5;\r\n}\r\n\r\n.mtb-timer {\r\n    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, Roboto, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 800;\r\n    font-variant-numeric: tabular-nums;\r\n    color: var(--tg-theme-text-color);\r\n}\r\n\r\n/* Добавляем букву s */\r\n.mtb-timer::after {\r\n    content: 's';\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin-left: 1px;\r\n    text-transform: lowercase;\r\n}\r\n\r\n.mtb-timer.danger {\r\n    color: #ff3b30;\r\n    animation: pulse 1s infinite;\r\n    opacity: 1; /* Если опасно, убираем прозрачность */\r\n}\r\n\r\n.mtb-header-divider {\r\n    width: 2px;\r\n    height: 24px;\r\n    background-color: currentColor; /* Использует цвет текста родителя */\r\n    border-radius: 1px;\r\n    opacity: 0.3;\r\n}\r\n\r\n/* Контейнер названия фазы */\r\n.mtb-phase-container {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    pointer-events: none;\r\n    /* Полупрозрачность для фазы */\r\n    opacity: 0.5;\r\n}\r\n\r\n.mtb-phase-title {\r\n    font-size: 16px; /* Увеличили шрифт */\r\n    font-weight: 780; /* Сделали менее жирным (было 900) */\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    color: var(--tg-theme-text-color);\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 50%;\r\n}\r\n\r\n.mtb-header-spacer { width: 40px; }\r\n\r\n\r\n/* --- СТРОКА 2: ТАБЫ --- */\r\n.mtb-row-tabs {\r\n    /* Было 50px, уменьшаем на ~25% -> 38px */\r\n    height: 26px;\r\n    display: flex;\r\n    padding: 3px 6px 3px 6px;\r\n    gap: 6px;\r\n}\r\n\r\n.mtb-tab {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    border-radius: 7px;\r\n    background: transparent;\r\n    border: none;\r\n    color: var(--tg-theme-hint-color, #999);\r\n    cursor: pointer;\r\n    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n    overflow: hidden;\r\n}\r\n\r\n.mtb-tab.active {\r\n    background: var(--tg-theme-button-color, #3390ec);\r\n    color: var(--tg-theme-button-text-color, #ffffff);\r\n    box-shadow: 0 2px 8px rgba(51, 144, 236, 0.25);\r\n}\r\n.mtb-tab:active { transform: scale(0.96); }\r\n\r\n/* Иконки чуть меньше, чтобы влезло в 38px */\r\n.mtb-tab.icon-only .mtb-tab-icon { font-size: 20px; }\r\n.mtb-tab.with-text .mtb-tab-icon { font-size: 15px; }\r\n\r\n.mtb-tab.with-text {\r\n    flex-direction: row;\r\n    gap: 4px;\r\n    padding: 0 8px;\r\n}\r\n\r\n.mtb-tab-label {\r\n    font-size: 12px; /* Оставляем читаемым */\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    line-height: 1;\r\n    padding-top: 1px; /* Визуальная компенсация */\r\n}\r\n\r\n/* Бейджи */\r\n.mtb-alert-icon {\r\n    top: 4px; right: 4px; font-size: 12px;\r\n}\r\n\r\n.mtb-badge {\r\n    top: 2px; right: 2px;\r\n    font-size: 9px;\r\n    height: 14px; min-width: 14px;\r\n    padding: 0 3px;\r\n}\r\n\r\n@keyframes pulse {\r\n    0% { opacity: 1; transform: scale(1); }\r\n    50% { opacity: 0.7; transform: scale(0.95); }\r\n    100% { opacity: 1; transform: scale(1); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
